import React from 'react';

const AddBlockBtn = (props) => {
  return (
  	<React.Fragment>
	  	<div className="container section for-admin">
		  	<button className="editor__btn-addblock" onClick={() => props.onClick()}>Добавить блок</button>
	  	</div>
  	</React.Fragment>
  );
};

export default AddBlockBtn;
